import { getRRuleDescription } from '@kizen/rrule';
import TriggerCard from 'pages/AutomationEngine/Engine/Steps/TriggerCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step, t }) => {
  return t('Scheduled for {{rrule}}', {
    rrule: getRRuleDescription(step.details.rrule || ''),
  });
};

export default function Card({ step, ...others }) {
  return <TriggerCard {...others}>{content({ step })}</TriggerCard>;
}
